(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("GridList", [], factory);
	else if(typeof exports === 'object')
		exports["GridList"] = factory();
	else
		root["GridList"] = factory();
})(window, function() {
return 